import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  inventory: [],
  loading: true,
  numberOfItems: 0,
  pageCount: 0,
  page: 1,
  limit: 10,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  categoryId: 0,
};

const getInventoryStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const getInventorySuccess = (state, action) => {
  const items = action.data.items || [];
  const pagination = action.data.pagination || {};
  
  const dataToArray = items.map((item) => {
    const price = parseFloat(item.price) || 0;
    const discountPercent = parseFloat(item.discountPercent) || 0;
    const discountedPrice = price - (price * discountPercent / 100);
    const productName = item.product?.name || 'Unknown Product';
    
    return [
      productName,
      `QAR ${price.toFixed(2)}`,
      `${discountPercent}%`,
      `QAR ${discountedPrice.toFixed(2)}`,
      item.id,
    ];
  });

  return updateObject(state, {
    loading: false,
    inventory: dataToArray,
    numberOfItems: pagination.total || 0,
    pageCount: pagination.totalPages || 0,
  });
};

const getInventoryFail = (state, action) => {
  return updateObject(state, { loading: false, inventory: [] });
};

const updatePerPageSelectStart = (state, action) => {
  switch (action.name) {
    case "sortBy":
    case "sortOrder":
    case "categoryId":
      return updateObject(state, {
        [action.name]: action.value,
        page: 1,
      });
    case "limit":
      return updateObject(state, {
        limit: action.value,
        pageCount: Math.ceil(state.numberOfItems / action.value),
        page: 1,
      });
    default:
      return state;
  }
};

const updatePageSelectStart = (state, action) => {
  return updateObject(state, {
    page: action.value,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_INVENTORY_START:
      return getInventoryStart(state, action);
    case actionTypes.GET_INVENTORY_SUCCESS:
      return getInventorySuccess(state, action);
    case actionTypes.GET_INVENTORY_FAIL:
      return getInventoryFail(state, action);
    case actionTypes.UPDATE_SELECT_PER_PAGE_INVENTORY:
      return updatePerPageSelectStart(state, action);
    case actionTypes.UPDATE_SELECT_PAGE_INVENTORY:
      return updatePageSelectStart(state, action);
    default:
      return state;
  }
};

export default reducer;
